// extracted by mini-css-extract-plugin
export default {"wrapper":"DynamicData_wrapper__lbdpx","srLWrapperLayout":"DynamicData_srLWrapperLayout__ee0wF","bigFirst":"DynamicData_bigFirst__B+GG+","gridItem":"DynamicData_gridItem__FD1VC"};